import { render, staticRenderFns } from "./CompleteRegistrationOk.vue?vue&type=template&id=7a5ad971&scoped=true"
var script = {}
import style0 from "./CompleteRegistrationOk.vue?vue&type=style&index=0&id=7a5ad971&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5ad971",
  null
  
)

export default component.exports